import { render, staticRenderFns } from "./recyclingMoneyList.vue?vue&type=template&id=88b80d74&scoped=true"
import script from "./recyclingMoneyList.vue?vue&type=script&lang=js"
export * from "./recyclingMoneyList.vue?vue&type=script&lang=js"
import style0 from "./recyclingMoneyList.vue?vue&type=style&index=0&id=88b80d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b80d74",
  null
  
)

export default component.exports